import { defineStore } from 'pinia';

export const useAutoRefreshStore = defineStore('autoRefresh', {
  state: () => ({
    activeInstances: 0,
    timerId: null,
    instanceCounter: 0,
    lastTimeoutId: null,
    lastProtected: false,
    finalScheduled: false,
    refreshCount: 0,
  }),
  actions: {
    incrementInstances() {
      this.activeInstances = (Number(this.activeInstances) || 0) + 1;
    },
    decrementInstances() {
      this.activeInstances = Math.max(0, (Number(this.activeInstances) || 1) - 1);
    },
    clearTimer() {
      try { if (this.timerId) { clearInterval(this.timerId); this.timerId = null; } } catch (e) {}
    },
    clearLastTimeout() {
      try { if (this.lastTimeoutId) { clearTimeout(this.lastTimeoutId); this.lastTimeoutId = null; } } catch (e) {}
    },
    reset() {
      this.clearTimer();
      this.clearLastTimeout();
      this.finalScheduled = false;
      this.lastProtected = false;
      this.refreshCount = 0;
      this.instanceCounter = 0;
      this.activeInstances = 0;
    }
  }
});
